import React, { useRef, useEffect } from 'react'
import { animateFadeLeft, animateStagger, animateParallax } from '../animations/animations'

function Faq() {
    const sectionRef = useRef(null)
    const parallaxRef = useRef(null)

    useEffect(() => {
        const subtitle = sectionRef.current?.querySelector('.subtitle');
        const title = sectionRef.current?.querySelector('.title');
        const cards = sectionRef.current?.querySelectorAll('.card');

        if (subtitle) animateFadeLeft(subtitle, 0.2);
        if (title) animateFadeLeft(title, 0.4);
        if (cards) animateStagger(cards, 0.6, 0.1);

        if (parallaxRef.current) animateParallax(parallaxRef.current, 0.1);

    }, [])

    return (
        <section className="question__area overflow-hidden section-space question-bg" ref={sectionRef}>
            <div id="primary" className="shape-wrapper">
                <div className="container p-relative">
                    <div className="question__all-shape">
                        <div className="bg-shape">
                            <img className="upDown" src="assets/imgs/faq/faq-bg-shape.svg" alt="Abstract Background Shape" />
                        </div>
                        <div className="bulet-shape">
                            <img className="upDown-top" src="assets/imgs/faq/faq-bulet_shape.svg" alt="Bullet Point Decoration" />
                        </div>
                        <div className="close-shape">
                            <img className="zooming" src="assets/imgs/faq/cross.svg" alt="Decorative Cross Shape" />
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-6 col-md-6">
                            <div className="content-area">
                                <div className="faq">
                                    <div id="faq" className="accordion">
                                        <h6 className="subtitle">Have Any Question</h6>
                                        <h2 className="title mb-40">Frequently Ask Question</h2>
                                        <div className="card">
                                            <div className="card-header">
                                                <button className="card-link" data-bs-toggle="collapse" data-bs-target="#faq-1">
                                                    What types of ID card printers do you offer?
                                                </button>
                                            </div>
                                            <div id="faq-1" className="collapse" data-bs-parent="#faq">
                                                <div className="card-body">
                                                    <p>We provide a range of ID card printers suitable for various needs, including single-sided and dual-sided printing, as well as options for encoding smart cards and magnetic stripes.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <button className="card-link" data-bs-toggle="collapse" data-bs-target="#faq-2">
                                                    Do your printers support encoding options?
                                                </button>
                                            </div>
                                            <div id="faq-2" className="collapse" data-bs-parent="#faq">
                                                <div className="card-body">
                                                    <p>Yes, certain models offer encoding options for magnetic stripes, contact, and contactless smart cards.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <button className="card-link" data-bs-toggle="collapse" data-bs-target="#faq-3">
                                                    Is there a warranty on your ID card printers?
                                                </button>
                                            </div>
                                            <div id="faq-3" className="collapse" data-bs-parent="#faq">
                                                <div className="card-body">
                                                    <p>Yes, our printers come with a manufacturer's warranty, which varies by model. For example, some printers offer a two-year warranty.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <button className="card-link" data-bs-toggle="collapse" data-bs-target="#faq-4">
                                                    What types of cards can I print with your printers?
                                                </button>
                                            </div>
                                            <div id="faq-4" className="collapse" data-bs-parent="#faq">
                                                <div className="card-body">
                                                    <p>Our printers are versatile and can print various types of cards, including employee ID cards, student ID cards, membership cards, loyalty cards, and more</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-header">
                                                <button className="card-link" data-bs-toggle="collapse" data-bs-target="#faq-5">
                                                    How do I choose the right ID card printer for my needs?
                                                </button>
                                            </div>
                                            <div id="faq-5" className="collapse" data-bs-parent="#faq">
                                                <div className="card-body">
                                                    <p>Our team can assist you in selecting the appropriate printer based on your specific requirements, such as print volume, card type, security features, and budget.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-6">
                            <div className="media">
                                <img ref={parallaxRef} data-speed="0.2" src="assets/imgs/faq/faq.webp" alt="Nexus ID Systems FAQ Illustration" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Faq
